import { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// Local files
import { StyledListItem } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import { DELETE_SESSION } from 'helpers/confirmations';

const Item = ({ id, created_at, active_at }) => {
  const { openDeleteDialog } = useApp();

  return (
    <StyledListItem disablePadding>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='body1'>
          {`Created: ${new Date(created_at).toLocaleString('en-US', { day:'numeric', month:'short', year:'numeric', hour: 'numeric', minute: 'numeric', hour12: true })}`}
        </Typography>
        <Typography variant='body1'>
          {`Active: ${new Date(active_at).toLocaleString('en-US', { day:'numeric', month:'short', year:'numeric', hour: 'numeric', minute: 'numeric', hour12: true })}`}
        </Typography>
      </Box>
      <Button variant='outlined' onClick={() => openDeleteDialog({ id, type: DELETE_SESSION })}>Disconnect</Button>
    </StyledListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);